import React from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";

class BlogShare extends React.Component {


  render() {
    const shareUrl = window.location.href;
    const imageURL = this.props.blogBanner;        
    const title = "Welcome to Godrej";
    const titleForEmail = "Check out this interesting article I read on Godrej Interio Inspire: ";
    const subjectForEmail="Godrej Interio Inspire | ";
    const {blogTitle} = this.props;
    const {blogIntro} = this.props;
    let classNameForSocialMediaIcons= "";
    {this.props.isOnTop ?
      classNameForSocialMediaIcons = " social-icon-share-top":
      classNameForSocialMediaIcons = ""

    }
    return (

      <div className={`social-icon-share${classNameForSocialMediaIcons}`}>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@godrejinterio" />
        <meta name="twitter:title" content={this.props.blogTitle} />
        <meta name="twitter:description" content={this.props.blogIntro}/>
        <meta name="twitter:image" content={this.props.blogBanner} />
        <meta name="twitter:image:alt" content="Article Image" />
        <meta property="og:url" content={window.location.href}/>
        <meta property="og:type" content="article" />
        <meta property="og:title" content={this.props.blogTitle} />
        <meta property="og:description"content={this.props.blogIntro} />
        <meta property="og:image" content={this.props.blogBanner} />

        <ul>
          {/* this.props.isOnTop ? "" : <li className="title">
                        Share this article
                     </li> */}

          <li className="list">
            <WhatsappShareButton url={shareUrl} title={blogTitle}>
              <div className="iconImg">
                <img src={this.props.socialShareIcons.whatsapp.socialmediashareimage} onMouseOut={e => e.currentTarget.src = this.props.socialShareIcons.whatsapp.socialmediashareimage} onMouseOver={e => e.currentTarget.src = this.props.socialShareIcons.whatsapp.socialmediashareimagehover}></img>
              </div>
            </WhatsappShareButton>
          </li>
          <li className="list">
            <TwitterShareButton url={shareUrl} title={blogTitle}>
              <div className="iconImg">
                <img src={this.props.socialShareIcons.twitter.socialmediashareimage} onMouseOut={e => e.currentTarget.src = this.props.socialShareIcons.twitter.socialmediashareimage} onMouseOver={e => e.currentTarget.src = this.props.socialShareIcons.twitter.socialmediashareimagehover}></img>
              </div>
            </TwitterShareButton>
          </li>
          <li className="list">
            <FacebookShareButton url={shareUrl} title={blogTitle} quote={blogTitle}  imageURL={imageURL}>
              <div className="iconImg">
                <img src={this.props.socialShareIcons.facebook.socialmediashareimage} onMouseOut={e => e.currentTarget.src = this.props.socialShareIcons.facebook.socialmediashareimage} onMouseOver={e => e.currentTarget.src = this.props.socialShareIcons.facebook.socialmediashareimagehover}></img>
              </div>
            </FacebookShareButton>
          </li>
          <li className="list">
            <LinkedinShareButton url={shareUrl} quote={blogTitle}>
              <div className="iconImg">
                <img src={this.props.socialShareIcons.linkedin.socialmediashareimage} onMouseOut={e => e.currentTarget.src = this.props.socialShareIcons.linkedin.socialmediashareimage} onMouseOver={e => e.currentTarget.src = this.props.socialShareIcons.linkedin.socialmediashareimagehover}></img>
              </div>
            </LinkedinShareButton>
          </li>

          <li className="list">
            <EmailShareButton subject={`${subjectForEmail} ${blogTitle}`} url={`${titleForEmail} ${blogTitle} \n${blogIntro} \n${shareUrl}`}>
              <div className="iconImg">
                <img src={this.props.socialShareIcons.mail.socialmediashareimage}  onMouseOut={e => e.currentTarget.src = this.props.socialShareIcons.mail.socialmediashareimage} onMouseOver={e => e.currentTarget.src = this.props.socialShareIcons.mail.socialmediashareimagehover} ></img>
              </div>
            </EmailShareButton>
          </li>
        </ul>
      </div>
    );
  }
}

export default BlogShare;
